"use client";

import { useEffect } from "react";
import { Button } from "~/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { AlertCircle, Home } from "lucide-react";
import { Link } from "~/i18n/routing";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global Error:", error);
  }, [error]);

  return (
    <div className="bg-background flex min-h-screen flex-1 items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <div className="bg-primary/10 mx-auto mb-4 w-fit rounded-full p-3">
            <AlertCircle className="text-primary h-8 w-8" />
          </div>
          <CardTitle className="text-2xl font-bold italic">Coproflow</CardTitle>
          <CardDescription className="text-foreground mt-2 text-lg font-medium">
            Oups ! Quelque chose s&apos;est mal passé.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-muted-foreground text-center">
            L&apos;application a rencontré une erreur inattendue. Veuillez
            réessayer ou retourner à l&apos;accueil.
          </p>
          <div className="flex flex-col gap-3">
            <Button onClick={() => reset()} className="h-12 w-full text-lg">
              Réessayer
            </Button>
            <Button variant="ghost" asChild className="w-full">
              <Link href="/">Retourner à l&apos;accueil</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
